module.exports = __webpack_public_path__ + "static/media/profile_img.c7401ecc.png";